import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Play, Radio, Clock } from "lucide-react";

export default function SirenStream() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/videos").then((r) => { setVideos(r.data); setActive(r.data?.[0] || null); }).catch(() => {}); }, []);

  return (
    <Layout>
      <section className="relative py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <span className="label-gold">Module 02 · Broadcast</span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white mt-3 mb-12">
            Siren <span className="gold-shimmer">Stream</span>.
          </h1>

          <div className="grid lg:grid-cols-[1.6fr_1fr] gap-6">
            {/* Theater */}
            <div className="relative aspect-video bg-black border border-[#C9A227]/30 overflow-hidden">
              {active && (
                <>
                  <img src={active.thumbnail} alt={active.title} className="w-full h-full object-cover opacity-70"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent"/>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button className="w-20 h-20 rounded-full bg-[#C9A227] text-black flex items-center justify-center hover:scale-110 transition-transform pulse-gold">
                      <Play size={28} fill="currentColor" className="ml-1"/>
                    </button>
                  </div>
                  {active.live && (
                    <span className="absolute top-4 left-4 bg-red-600 text-white text-[10px] tracking-[0.2em] font-black uppercase px-2 py-1 flex items-center gap-1">
                      <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"/> LIVE
                    </span>
                  )}
                  <div className="absolute bottom-5 left-5 right-5">
                    <span className="text-[10px] tracking-[0.3em] uppercase text-[#C9A227] font-bold">{active.tag}</span>
                    <h3 className="text-white text-2xl md:text-3xl font-black uppercase tracking-tight mt-1">{active.title}</h3>
                  </div>
                </>
              )}
            </div>

            {/* Playlist */}
            <div className="space-y-2 max-h-[560px] overflow-y-auto pr-2 scroll-fade">
              {videos.map((v) => (
                <button key={v.id} onClick={() => setActive(v)}
                  className={`w-full text-left flex gap-3 p-2 border ${active?.id === v.id ? "border-[#C9A227]" : "border-[#C9A227]/10"} hover:border-[#C9A227]/60 transition-colors`}>
                  <div className="relative w-32 h-20 flex-shrink-0 overflow-hidden">
                    <img src={v.thumbnail} alt="" className="w-full h-full object-cover"/>
                    {v.live ? (
                      <span className="absolute top-1 left-1 bg-red-600 text-white text-[8px] px-1 font-bold">LIVE</span>
                    ) : (
                      <span className="absolute bottom-1 right-1 bg-black/80 text-white text-[10px] px-1 tabular-nums flex items-center gap-1">
                        <Clock size={9}/>{v.duration}
                      </span>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-[9px] tracking-[0.25em] uppercase text-[#C9A227] font-bold">{v.tag}</div>
                    <div className="text-white text-sm font-bold leading-tight mt-1 truncate">{v.title}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
